import type Sort from '~/type/Sort'

export default function (el: { [key: string]: any }): Sort {
  return {
    active: el.ACTIVE === 'Y',
    name: el.NAME,
    value: el.SORT?.BY,
  }
}
